import PasswordInput from '../../PasswordInput';
import { AuthField, AuthHint, AuthLabel } from '../../authModal.styles';
import { AUTH_STEPS } from '../constants/authForm.constants';

const FIELD_IDS = {
	[AUTH_STEPS.PASSWORD_REGISTER]: {
		password: 'auth-password-register',
		confirm: 'auth-confirm-password',
	},
	[AUTH_STEPS.PASSWORD_SET]: {
		password: 'auth-password-set',
		confirm: 'auth-confirm-password-set',
	},
};

const AuthPasswordRegisterFields = ({
	step,
	password,
	confirmPassword,
	onPasswordChange,
	onConfirmPasswordChange,
	translations,
}) => {
	const fieldIds = FIELD_IDS[step];
	const isSetPasswordStep = step === AUTH_STEPS.PASSWORD_SET;

	return (
		<>
			<AuthField>
				<AuthLabel htmlFor={fieldIds.password}>
					{translations.passwordLabelRegister || 'Set Password'}
				</AuthLabel>
				<PasswordInput
					id={fieldIds.password}
					placeholder={
						isSetPasswordStep
							? translations.passwordSetPlaceholder || 'create your password'
							: translations.passwordPlaceholder || 'enter new password'
					}
					value={password}
					onChange={(event) => onPasswordChange(event.target.value)}
					minLength={6}
					autoFocus
					showPasswordLabel={translations.showPassword}
					hidePasswordLabel={translations.hidePassword}
					autoComplete="new-password"
				/>
				<AuthHint>
					{translations.passwordRequirements || 'At least 6 characters.'}
				</AuthHint>
			</AuthField>
			<AuthField>
				<AuthLabel htmlFor={fieldIds.confirm}>
					{translations.confirmPasswordLabel || 'Confirm Password'}
				</AuthLabel>
				<PasswordInput
					id={fieldIds.confirm}
					placeholder={
						translations.confirmPasswordPlaceholder || 'repeat new password'
					}
					value={confirmPassword}
					onChange={(event) => onConfirmPasswordChange(event.target.value)}
					minLength={6}
					showPasswordLabel={translations.showPassword}
					hidePasswordLabel={translations.hidePassword}
					autoComplete="new-password"
				/>
			</AuthField>
		</>
	);
};

export default AuthPasswordRegisterFields;
